var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProviderFilter = function SvgProviderFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.398 5.315c0 1.556-1.282 2.817-2.866 2.817-1.582 0-2.865-1.261-2.865-2.817C1.667 3.761 2.95 2.5 4.532 2.5c1.584 0 2.866 1.26 2.866 2.815Zm9.68-1.233c.692 0 1.255.553 1.255 1.233 0 .682-.563 1.235-1.255 1.235h-5.48a1.246 1.246 0 0 1-1.257-1.235c0-.68.564-1.233 1.257-1.233h5.48ZM2.923 13.298h5.48c.693 0 1.256.553 1.256 1.235 0 .68-.563 1.234-1.256 1.234h-5.48a1.247 1.247 0 0 1-1.256-1.234c0-.682.562-1.235 1.256-1.235Zm12.544 4.017c1.584 0 2.866-1.261 2.866-2.816s-1.282-2.816-2.866-2.816c-1.582 0-2.865 1.26-2.865 2.816 0 1.555 1.283 2.816 2.865 2.816Z",
    fill: "#ADADAD"
  })));
};
export default SvgProviderFilter;